export const BLUE = "#333399";
export const BLUETRANSPARENT = "#333399F2";
export const BLUEGRADIENT =
  "linear-gradient(to left, #3E4095, #383a95eb, #3E4095)";
export const LIGHTBLUE = "#b3b3e6";
export const YELLOW = "#fffe00";
export const GREEN = "#5dff79";
export const CYAN = "#56f3ff";
export const PINK = "#ffcaf7";
export const ORANGE = "#ffc66f";
